import { useQuery } from "@tanstack/react-query";

import { useAuth } from "../../features/auth/AuthContext";
import { TimeRange } from "../../utils/timerange";
import { fetchDashboardData } from "../queries/dashboard";

interface UseDashboardDataParams {
  timeRange: TimeRange;
  timezone: string;
  protocol: string;
  user: string;
  callType: string;
  permittedEmails: string[] | null;
}

export const useDashboardData = (params: UseDashboardDataParams) => {
  const { tenantId } = useAuth();
  const { timeRange, timezone, protocol, user, callType, permittedEmails } = params;

  return useQuery({
    queryKey: ["dashboardData", tenantId, timeRange, timezone, protocol, user, callType, permittedEmails],
    queryFn: () => fetchDashboardData(params),
    staleTime: 1 * 60 * 1000, // 1 minute - dashboard data changes moderately frequently
    gcTime: 2 * 60 * 1000, // 2 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000)
  });
};
